





























import { Prop } from "vue-property-decorator";
import { Component, Mixins } from "vue-mixin-decorator";
import TabsComponent from "@/app/basic/common/components/tab-component/TabsComponent.vue";
import ComponentVue from "@/app/core/window/ComponentVue";

@Component({
  components: { TabsComponent }
})
export default class SCheck extends Mixins<ComponentVue>(ComponentVue) {
  @Prop({ type: Boolean, required: true })
  private value!: boolean;

  @Prop({ type: Boolean, default: false })
  private iconBefore!: boolean;

  @Prop({ type: String, default: "skyblue" })
  private colorStyle!: string;

  @Prop({ type: String, required: true })
  private cIcon!: string;

  @Prop({ type: String, required: true })
  private cLabel!: string;

  @Prop({ type: String, required: true })
  private nIcon!: string;

  @Prop({ type: String, required: true })
  private nLabel!: string;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean;

  private get localValue(): boolean {
    return this.value;
  }

  private set localValue(value: boolean) {
    this.input(value);
  }

  private input(value: boolean) {
    this.$emit("input", value);
  }

  private onClick() {
    if (this.disabled || this.readonly) return;
    this.localValue = !this.localValue;
  }
}
